export default __webpack_public_path__ + "static/media/sync_warning.43649efd.svg";